import { render } from "./NewDevice.vue?vue&type=template&id=358e0970"
import script from "./NewDevice.vue?vue&type=script&lang=js"
export * from "./NewDevice.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__